module.exports = __webpack_public_path__ + "img/cloud3.078a94ba.webp";